var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M36.32 3.4c-1.33.58-2.75.97-4.23 1.15A7.23 7.23 0 0035.32.54a14.75 14.75 0 01-4.65 1.76A7.38 7.38 0 0025.3 0a7.3 7.3 0 00-7.16 8.92c-6.1-.3-11.5-3.19-15.12-7.6a7.25 7.25 0 002.25 9.7 7.3 7.3 0 01-3.31-.89v.08a7.31 7.31 0 005.88 7.14 7.4 7.4 0 01-3.32.11 7.4 7.4 0 006.86 5.06 14.83 14.83 0 01-10.85 3 20.8 20.8 0 0011.25 3.26c13.5 0 20.88-11.07 20.88-20.66 0-.33-.01-.64-.03-.94a14.55 14.55 0 003.68-3.77z","fill":"currentColor","fillRule":"nonzero"}));
}

Twitter.defaultProps = {"viewBox":"0 0 37 29"};

module.exports = Twitter;

Twitter.default = Twitter;
